<template>
  <div id="contenedor-nueva-respuesta-detalle">
    <v-form
      v-model="formularioValido"
      ref="registraNuevaAuditoriaInformeRepuestaDetalle">
      <v-card>
        <v-card-title>
          Selecciona Detalle
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text v-if="existenDesglosesPendientes">
          <v-card flat>
            <v-row>
              <v-col>
                <span class="text-h4 font-weight-bold azul2--text">
                  {{informe.numeroOficio}}
                </span>
              </v-col>
            </v-row>
          </v-card>

          <v-list class="pa-4 dense">
            <v-list-item
            v-for="(detalle, index) in getObservacionesDesglosesParciales"
            :key="`${detalle.id}-${index}`"
            class="list-item">
            <v-row align="center">
              <v-col cols="2">
                <v-checkbox
                :id="`enviado-${detalle.id}-${index}`"
                  v-model="detalle.enviado"
                  :value="detalle.enviado"
                  label=""
                  color="secondary"
                  hide-details
                  class="my-0 mx-2">
                </v-checkbox>
              </v-col>
              <v-col cols="10">
                <v-list-item-content>
                  <v-list-item-title class="azul2--text font-weight-bold text-lg">
                    {{detalle.observacion.numero}}
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-caption text-wrap mb-2">
                   <span class="text-caption font-weight-light"
                      v-if="detalle.observacion">
                      <cortar-texto
                      :texto="detalle.observacion ? detalle.observacion.descripcion : ''">
                    </cortar-texto></span>
                  </v-list-item-subtitle>
                  <v-list-item-title class="naranja--text h5 font-weight-bold ">
                    {{detalle.contrato}}
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-caption text-wrap" >
                    <span class="text-caption font-weight-light"
                      v-if="detalle.texto">
                      <cortar-texto
                      :texto="detalle.texto">
                      </cortar-texto></span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-col>
            </v-row>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-text v-else>
          <span>
            No existen desgloses a seleccionar
          </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
            </custom-button>
          <custom-button
            @click="guardar"
            tipo="formAceptar"
            label="Guardar"
            :disabled="!formularioValido || enviandoFormulario || !existenDesglosesPendientes"
            :loading="enviandoFormulario"
            >
            </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';
import CortarTexto from '@/components/CortarTextos.vue';
import mixRespuestas from '../mixRespuestas';
import mixEvaluacionRepuestas from './mixEvaluacionRepuestas';

export default {
  name: 'RegistrarNuevaRespuestaDetalle',
  mixins: [mixRespuestas, mixEvaluacionRepuestas],
  props: {
    informe: {
      type: Object,
      required: true,
    },
    respuesta: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
    CortarTexto,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      respuestaDetalle: {
        idAuditoriaInformeRespuesta: this.respuesta.id,
        idAuditoriaInformeObservacionDetalle: '',
        esRespuestaParcial: false,
        comentarios: null,
      },
      respuestaDetalles: [],
    };
  },
  methods: {
    async guardar() {
      const respuestasDetallesSeleccionados = this.getObservacionesDesglosesParciales.slice()
        .filter((detalle) => detalle.enviado === true)
        .map((detalle) => ({
          idAuditoriaInformeRespuesta: this.respuesta.id,
          idAuditoriaInformeObservacionDetalle: detalle.id,
          esRespuestaParcial: false,
          comentarios: '',
        }));
      this.respuestaDetalles = respuestasDetallesSeleccionados;
      await this.mixAgregarRespuestaDetalle();
    },
    limpiarFormularioRespuestaDetalle() {
      this.$refs.registraNuevaAuditoriaInformeRepuestaDetalle.reset();
    },
    cerrar() {
      this.limpiarFormularioRespuestaDetalle();
      this.$emit('cerrar');
    },
  },
  computed: {
    getAuditoriaInformeObservaciones() {
      if (!this.auditoriaInforme) return [];
      return this.auditoriaInforme.observaciones;
    },
    getObservacionesDesglosesParciales() {
      const desglosesParciales = this.auditoriaInforme.observaciones
        ? this.informe.observaciones
          .flatMap((observacion) => observacion.detalles
            .filter((detalle) => !detalle.enviado)
            .map((detalle) => ({
              id: detalle.id,
              enviado: detalle.enviado,
              texto: detalle.texto || '',
              esRespuestaParcial: true,
              comentarios: '',
              contrato: detalle.contrato !== null ? detalle.contrato.numero : '',
              numeroObservacion: observacion.numero,
              observacion: {
                id: observacion.id,
                numero: observacion.numero,
                descripcion: observacion.descripcion,
              },
            })))
          .sort((a, b) => ((`${a.numeroObservacion}`).localeCompare(b.numeroObservacion)))
        : [];
      return desglosesParciales;
    },
    getAuditoriaInforme() {
      if (!this.auditoriaInforme) return [];
      return this.auditoriaInforme;
    },
    existenDesglosesPendientes() {
      if (this.getObservacionesDesglosesParciales.length > 0) return true;
      return false;
    },
  },
};
</script>

<style scoped lang="scss">
.list-item{
  border-bottom: 1px solid #e0e0e0;
  padding: 16px 0;
}
.text-wrap{
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
}
.text-lg{
  font-size: 1.25rem;
}
</style>
